import { useContext } from 'react';
import { ToastContext } from 'application/providers/toast.provider';

export default function useToast() {
  return useContext(ToastContext)!;
}
